import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DateTimePickerComponent} from "./components/date-time-picker/date-time-picker.component";
import {FormsModule} from "@angular/forms";
import {NgxMaskModule} from "ngx-mask";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {FooterComponent} from "./components/footer/footer.component";
import {NoAccessComponent} from "./components/no-access/no-access.component";
import {MultiselectComponent} from "./components/multiselect/multiselect.component";
import {NgSelectModule} from "@ng-select/ng-select";
import {SensorMultiselectComponent} from "./components/sensor-multiselect/sensor-multiselect.component";
import {SelectComponent} from "./components/select/select.component";
import {SearchPipe} from "./pipes/search.pipe";
import {NewSearchPipe} from "./pipes/new-search.pipe";
import {FilterPipe} from "./pipes/filter.pipe";
import {NewUserFilterPipe} from "./pipes/new-user-filter.pipe";
import {UserFilterPipe} from "./pipes/user-filter.pipe";
import {ErrorColorDirective} from "./directives/error-color.directive";
import {ReplaceNanPipe} from "./pipes/replace-nan.pipe";
import {TranslateModule} from "@ngx-translate/core";
import {AdminHeadersComponent} from "./components/admin-headers/admin-headers.component";
import {RouterModule} from "@angular/router";
import {ClockComponent} from "./components/clock/clock.component";
import {MenubarModule} from "primeng/menubar";
import {NameInputDirective} from "./directives/name-input.directive";
import {MenuComponent} from "./components/menu/menu.component";
import {RedirectDialogComponent} from "./dialogs/redirect-dialog/redirect-dialog.component";
import {ClassAlertDialogComponent} from "./dialogs/class-alert-dialog/class-alert-dialog.component";
import {CreateDialogComponent} from "./dialogs/create-dialog/create-dialog.component";
import {DeleteDialogComponent} from "./dialogs/delete-dialog/delete-dialog.component";
import {ExportDialogComponent} from "./dialogs/export-dialog/export-dialog.component";
import {HelpDialogComponent} from "./dialogs/help-dialog/help-dialog.component";
import {LogErrorsDialogComponent} from "./dialogs/log-errors-dialog/log-errors-dialog.component";
import {MapDialogComponent} from "./dialogs/map-dialog/map-dialog.component";
import {NgxPaginationModule} from "ngx-pagination";
import {SensorMoveDialogComponent} from "./sensor-move-dialog/sensor-move-dialog.component";
import {ToSensorConfigDialogComponent} from "./dialogs/to-sensor-config-dialog/to-sensor-config-dialog.component";
import { SortTableColumnComponent } from './components/sort-table-column/sort-table-column.component';
import {MatDialogModule} from "@angular/material/dialog";
import { ButtonComponent } from './components/button/button.component';
import {MatTabsModule} from "@angular/material/tabs";
@NgModule({
  declarations: [
    // Pipes
    SearchPipe,
    NewSearchPipe,
    FilterPipe,
    UserFilterPipe,
    NewUserFilterPipe,
    ReplaceNanPipe,

    // Directives
    ErrorColorDirective,
    NameInputDirective,

    // Dialogs
    RedirectDialogComponent,
    ClassAlertDialogComponent,
    CreateDialogComponent,
    DeleteDialogComponent,
    ExportDialogComponent,
    HelpDialogComponent,
    LogErrorsDialogComponent,
    MapDialogComponent,
    SensorMoveDialogComponent,
    ToSensorConfigDialogComponent,

    // Components
    DateTimePickerComponent,
    FooterComponent,
    NoAccessComponent,
    MultiselectComponent,
    SensorMultiselectComponent,
    SelectComponent,
    AdminHeadersComponent,
    ClockComponent,
    MenuComponent,
    SortTableColumnComponent,
    ButtonComponent,
  ],
  exports: [
    // Pipes
    SearchPipe,
    NewSearchPipe,
    FilterPipe,
    UserFilterPipe,
    NewUserFilterPipe,
    ReplaceNanPipe,

    // Directives
    ErrorColorDirective,
    NameInputDirective,

    // Other
    TranslateModule,

    // Dialogs
    RedirectDialogComponent,
    ClassAlertDialogComponent,
    CreateDialogComponent,
    DeleteDialogComponent,
    ExportDialogComponent,
    HelpDialogComponent,
    LogErrorsDialogComponent,
    MapDialogComponent,
    SensorMoveDialogComponent,
    ToSensorConfigDialogComponent,

    // Components
    DateTimePickerComponent,
    FooterComponent,
    NoAccessComponent,
    MultiselectComponent,
    SensorMultiselectComponent,
    SelectComponent,
    AdminHeadersComponent,
    ClockComponent,
    MenuComponent,
    SortTableColumnComponent,
    ButtonComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxMaskModule,
    NgbModule,
    NgSelectModule,
    TranslateModule,
    RouterModule,
    MenubarModule,
    NgxPaginationModule,
    MatDialogModule,
    MatTabsModule
  ],
  providers: []
})
export class SharedModule {
}
